import throttleUtility from 'javascripts/modules/util.throttle.js';

let instance = null;

class VisibilityState {

	constructor(){
		if (!instance) {
      instance            = this;
      this.elements       = document.querySelectorAll('[data-visibility]');
      this.visibleEvent   = null;
      this.invisibleEvent = null;
      this.defaultOffset  = {
				top   : 0,
				bottom: 0
			};
	  	this._init();
    }
    return instance;
	}

	_init(){
		document.addEventListener('DOMContentLoaded', (event) => {

			this._initEvents();
			this._checkVisibility();

			window.addEventListener('scroll', throttleUtility(
				()=>this._checkVisibility(), 500)
			);

			const modals = document.querySelectorAll('[data-modal]');
			for (let modal of modals) {
				modal.addEventListener('scroll', throttleUtility(
					()=>this._checkVisibility(), 500)
				);
			}

		});
	}


	_initEvents(){
		this.visibleEvent   = document.createEvent('Event');
		this.invisibleEvent = document.createEvent('Event');
		this.visibleEvent.initEvent('visible', true, true);
		this.invisibleEvent.initEvent('invisible', true, true);
	}


	_checkVisibility(){
		for (const element of this.elements){

			const dataVisibility = element.getAttribute('data-visibility');

			if(this._isVisible(element) && dataVisibility !== 'visible'){

				this._setVisibility(element, 'visible', this.visibleEvent);

			} else if (!this._isVisible(element) && dataVisibility !== 'invisible'){
				
				this._setVisibility(element, 'invisible', this.invisibleEvent);
			}
  	}
	}

	refresh(params){

		this.elements       = params;
		this.visibleEvent   = null;
		this.invisibleEvent = null;

		this._initEvents();
		this._checkVisibility();
	}


	_isVisible(element){
		const screenHeight = (window.innerHeight || document.documentElement.clientHeight);
		const rect   = element.getBoundingClientRect();
		let offset = JSON.parse(element.getAttribute('data-visibility-offset')) || this.defaultOffset;
		
		offset = this._convertPercent(offset, screenHeight);

		const testVisibility = (
			rect.bottom >= offset.top && 
			rect.left   >= 0 && 
			rect.top    <= screenHeight - offset.bottom
    );
    return testVisibility;
	}

	_setVisibility(element, state, event){
		element.setAttribute('data-visibility', state);
		element.dispatchEvent(event);
	}

	_convertPercent(offset, height){
		const topData = String(offset.top).match(/([0-9]+)\%/);
		if(topData && topData[1]){
			offset.top = height * topData[1] / 100;
		}

		const bottomData = String(offset.bottom).match(/([0-9]+)\%/);
		if(bottomData && bottomData[1]){
			offset.bottom = height * bottomData[1] / 100;
		}
		
		return offset;
	}

}

export default VisibilityState;
const visibilityState = new VisibilityState();